<div class="d-flex">
    <span *ngFor="let index of numbers"
        class="dot"
        [ngClass]="{ active: index === current }">
        ●
    </span>
</div>